(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };

  class CartTruncateText extends HTMLElement {
    constructor() {
      super();
      this.truncateLength = parseInt(this.getAttribute('truncate-length')) || 5;
      this.originalText = '';
      this.isExpanded = false;
      this.toggleButton = null;
    }

    connectedCallback() {
      const toggleButton = this.querySelector('.toggle-text');
      if (!toggleButton) return;

      this.toggleButton = toggleButton;
      toggleButton.remove();

      this.originalText = this.innerHTML.trim();
      this.appendChild(toggleButton);

      toggleButton.addEventListener('click', this.toggleTruncate.bind(this));
      this.truncateContent();
    }

    truncateContent() {
      const words = this.originalText.trim().split(/\s+/);
      if (words.length <= this.truncateLength) {
        this.toggleButton.style.display = 'none';
        return;
      }

      this.innerHTML = '';

      // Use Shopify translation text stored in data attributes
      const readMoreText = this.dataset.readMoreText || window.read_more_text || 'Read more';
      const readLessText = this.dataset.readLessText || window.read_less_text || 'Read less';

      if (!this.isExpanded) {
        const truncatedText = words.slice(0, this.truncateLength).join(' ') + '... ';
        this.appendChild(document.createTextNode(truncatedText));
        this.toggleButton.textContent = readMoreText;
      } else {
        this.appendChild(document.createTextNode(this.originalText));
        this.toggleButton.textContent = readLessText;
      }

      this.appendChild(this.toggleButton);
    }

    toggleTruncate(event) {
      event.preventDefault();
      this.isExpanded = !this.isExpanded;
      this.truncateContent();
    }
  }
  if (!customElements.get('cart-truncate-text')) customElements.define('cart-truncate-text', CartTruncateText);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-line-item-compact"] && !Shopify.designMode) return;
  try {
    const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-localization"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class LocalizationDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.items = this.content.querySelectorAll('[data-submit-btn]');
      const doAnimate = (element) => {
        const { frames, options } = this.content.dataset;
        if (!frames || !options) return;
        try {
          element.animate(JSON.parse(frames), JSON.parse(options));
        } catch (e) {
          console.warn('LocalizationDropdown: Animation data missing or invalid', e);
        }
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(this.dataset.formId);
        const input = this.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const onBodyClick = (event) => { if (!this.contains(event.target)) closeDropdown(); };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', 'true');
        this.content.classList.add('dropdown--open');
        doAnimate(this.content);
        this.content.focus();
        trapFocus(this.content);
        document.body.addEventListener('click', onBodyClick);
        this.addEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.addEventListener('click', select));
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', 'false');
        this.content.classList.remove('dropdown--open');
        trapFocus(null, this.button, false);
        document.body.removeEventListener('click', onBodyClick);
        this.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.removeEventListener('click', select));
      };
      const onToggleClick = () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        isExpanded ? closeDropdown() : openDropdown();
      };
      this.button.addEventListener('click', onToggleClick);
      this._onToggleClick = onToggleClick;
      this._select = select;
      this._closeDropdown = closeDropdown;
      this.select = select;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
    disconnectedCallback() {
      if (this.button && this._onToggleClick) this.button.removeEventListener('click', this._onToggleClick);
      if (this.items && this._select) this.items.forEach((item) => item.removeEventListener('click', this._select));
      if (this._closeDropdown) this._closeDropdown();
    }
  }
  if (!customElements.get('localization-dropdown')) customElements.define('localization-dropdown', LocalizationDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-burger-left-structure"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalBurgerMenuToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-burger-menu-toggler')) customElements.define('modal-burger-menu-toggler', ModalBurgerMenuToggler);
  class ModalBurgerMenuComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        self.querySelectorAll('menu-burger-dropdown').forEach((dropdown) => {
          if (dropdown.closeDropdown && dropdown.content && dropdown.content.classList.contains('dropdown--open')) {
            dropdown.closeDropdown();
          }
        });
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-burger-menu-component')) customElements.define('modal-burger-menu-component', ModalBurgerMenuComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-burger-right-structure"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalBurgerMenuToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-burger-menu-toggler')) customElements.define('modal-burger-menu-toggler', ModalBurgerMenuToggler);
  class ModalBurgerMenuComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        self.querySelectorAll('menu-burger-dropdown').forEach((dropdown) => {
          if (dropdown.closeDropdown && dropdown.content && dropdown.content.classList.contains('dropdown--open')) {
            dropdown.closeDropdown();
          }
        });
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-burger-menu-component')) customElements.define('modal-burger-menu-component', ModalBurgerMenuComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-logo-center-alter-structure"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalMenuToggler extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-menu-toggler')) customElements.define('modal-menu-toggler', ModalMenuToggler);
  class ModalMenuComponent extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      if (window.screen.width > 991) return;
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        self.querySelectorAll('menu-dropdown').forEach((dropdown) => {
          if (dropdown.closeDropdown && dropdown.content && dropdown.content.classList.contains('dropdown--open')) {
            dropdown.closeDropdown();
          }
        });
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-menu-component')) customElements.define('modal-menu-component', ModalMenuComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-logo-center-structure"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalMenuToggler extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-menu-toggler')) customElements.define('modal-menu-toggler', ModalMenuToggler);
  class ModalMenuComponent extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      if (window.screen.width > 991) return;
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        self.querySelectorAll('menu-dropdown').forEach((dropdown) => {
          if (dropdown.closeDropdown && dropdown.content && dropdown.content.classList.contains('dropdown--open')) {
            dropdown.closeDropdown();
          }
        });
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-menu-component')) customElements.define('modal-menu-component', ModalMenuComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-logo-left-structure"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalMenuToggler extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-menu-toggler')) customElements.define('modal-menu-toggler', ModalMenuToggler);
  class ModalMenuComponent extends HTMLElement {
    constructor() {
      super();
      if (window.screen.width > 991) return;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      if (window.screen.width > 991) return;
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        self.querySelectorAll('menu-dropdown').forEach((dropdown) => {
          if (dropdown.closeDropdown && dropdown.content && dropdown.content.classList.contains('dropdown--open')) {
            dropdown.closeDropdown();
          }
        });
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-menu-component')) customElements.define('modal-menu-component', ModalMenuComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-localization"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class LocalizationDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.items = this.content.querySelectorAll('[data-submit-btn]');
      const doAnimate = (element) => {
        const { frames, options } = this.content.dataset;
        if (!frames || !options) return;
        try {
          element.animate(JSON.parse(frames), JSON.parse(options));
        } catch (e) {
          console.warn('LocalizationDropdown: Animation data missing or invalid', e);
        }
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(this.dataset.formId);
        const input = this.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const onBodyClick = (event) => { if (!this.contains(event.target)) closeDropdown(); };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', 'true');
        this.content.classList.add('dropdown--open');
        doAnimate(this.content);
        this.content.focus();
        trapFocus(this.content);
        document.body.addEventListener('click', onBodyClick);
        this.addEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.addEventListener('click', select));
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', 'false');
        this.content.classList.remove('dropdown--open');
        trapFocus(null, this.button, false);
        document.body.removeEventListener('click', onBodyClick);
        this.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.removeEventListener('click', select));
      };
      const onToggleClick = () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        isExpanded ? closeDropdown() : openDropdown();
      };
      this.button.addEventListener('click', onToggleClick);
      this._onToggleClick = onToggleClick;
      this._select = select;
      this._closeDropdown = closeDropdown;
      this.select = select;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
    disconnectedCallback() {
      if (this.button && this._onToggleClick) this.button.removeEventListener('click', this._onToggleClick);
      if (this.items && this._select) this.items.forEach((item) => item.removeEventListener('click', this._select));
      if (this._closeDropdown) this._closeDropdown();
    }
  }
  if (!customElements.get('localization-dropdown')) customElements.define('localization-dropdown', LocalizationDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["line-item-compact"] && !Shopify.designMode) return;
  try {
    const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => arr.push(document.querySelector(selector)));
    return arr;
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-burger-dropdown-marquee"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuBurgerDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-burger-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-burger-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        this.content.style.maxHeight = '100vh';
        this.content.style.overflowY = 'auto';
        if (isLevel2 && outerSelf && outerSelf.content) outerSelf.content.style.overflowY = 'hidden';
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.finished.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          }).catch(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-burger-dropdown')) customElements.define('menu-burger-dropdown', MenuBurgerDropdown);
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-burger-dropdown-products"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuBurgerDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-burger-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-burger-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        this.content.style.maxHeight = '100vh';
        this.content.style.overflowY = 'auto';
        if (isLevel2 && outerSelf && outerSelf.content) outerSelf.content.style.overflowY = 'hidden';
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.finished.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          }).catch(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-burger-dropdown')) customElements.define('menu-burger-dropdown', MenuBurgerDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-dropdown-marquee"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        if (window.innerWidth > 991) {
          if (isLevel2) {
            this.content.style.position = 'fixed';
            const linkRect = this.firstElementChild.getBoundingClientRect();
            let topPosition = linkRect.top;
            let leftPosition = linkRect.right + 5;
            this.content.style.top = `${topPosition}px`;
            this.content.style.left = `${leftPosition}px`;
            const contentWidth = this.content.offsetWidth || 232;
            if (leftPosition + contentWidth > window.innerWidth) this.content.style.left = `${Math.max(0, linkRect.left - contentWidth - 5)}px`;
            if (outerSelf && outerSelf.content) {
              this.onParentScroll = () => closeDropdown();
              outerSelf.content.addEventListener('scroll', this.onParentScroll, { passive: true });
            }
          }
          const rect = this.content.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const padding = 15;
          if (rect.bottom > viewportHeight) {
            if (isLevel2) {
              const overflowAmount = rect.bottom - viewportHeight + padding;
              let currentTop = parseFloat(this.content.style.top) || rect.top;
              const maxShift = Math.max(0, currentTop - padding);
              const actualShift = Math.min(overflowAmount, maxShift);
              this.content.style.top = `${currentTop - actualShift}px`;
              if (overflowAmount > maxShift) {
                this.content.style.maxHeight = `${viewportHeight - (padding * 2)}px`;
                this.content.style.overflowY = 'auto';
              }
            } else {
              this.content.style.maxHeight = `${Math.max(100, viewportHeight - rect.top - padding)}px`;
              this.content.style.overflowY = 'auto';
            }
          }
        } else {
          this.content.style.maxHeight = '100vh';
          this.content.style.overflowY = 'auto';
          if (isLevel2 && outerSelf && outerSelf.content) outerSelf.content.style.overflowY = 'hidden';
        }
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.finished.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          }).catch(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-dropdown')) customElements.define('menu-dropdown', MenuDropdown);
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-dropdown-products"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        if (window.innerWidth > 991) {
          if (isLevel2) {
            this.content.style.position = 'fixed';
            const linkRect = this.firstElementChild.getBoundingClientRect();
            let topPosition = linkRect.top;
            let leftPosition = linkRect.right + 5;
            this.content.style.top = `${topPosition}px`;
            this.content.style.left = `${leftPosition}px`;
            const contentWidth = this.content.offsetWidth || 232;
            if (leftPosition + contentWidth > window.innerWidth) this.content.style.left = `${Math.max(0, linkRect.left - contentWidth - 5)}px`;
            if (outerSelf && outerSelf.content) {
              this.onParentScroll = () => closeDropdown();
              outerSelf.content.addEventListener('scroll', this.onParentScroll, { passive: true });
            }
          }
          const rect = this.content.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const padding = 15;
          if (rect.bottom > viewportHeight) {
            if (isLevel2) {
              const overflowAmount = rect.bottom - viewportHeight + padding;
              let currentTop = parseFloat(this.content.style.top) || rect.top;
              const maxShift = Math.max(0, currentTop - padding);
              const actualShift = Math.min(overflowAmount, maxShift);
              this.content.style.top = `${currentTop - actualShift}px`;
              if (overflowAmount > maxShift) {
                this.content.style.maxHeight = `${viewportHeight - (padding * 2)}px`;
                this.content.style.overflowY = 'auto';
              }
            } else {
              this.content.style.maxHeight = `${Math.max(100, viewportHeight - rect.top - padding)}px`;
              this.content.style.overflowY = 'auto';
            }
          }
        } else {
          this.content.style.maxHeight = '100vh';
          this.content.style.overflowY = 'auto';
          if (isLevel2 && outerSelf && outerSelf.content) outerSelf.content.style.overflowY = 'hidden';
        }
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.finished.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          }).catch(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-dropdown')) customElements.define('menu-dropdown', MenuDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-dropdown"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuMegaDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-mega-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-mega-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (outerSelf.content) outerSelf.content.classList.remove('overflow-hidden');
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        document.body.classList.add('overflow-hidden');
        if (window.innerWidth > 991) {
          if (!isLevel2) {
            setTimeout(() => {
              const firstLevel2 = this.querySelector('menu-mega-dropdown[data-level="2"]');
              if (firstLevel2) firstLevel2.openDropdown();
            }, 100);
          }
        } else {
          if (isLevel2 && outerSelf && outerSelf.content) {
             // We still need a way to prevent scrolling the parent menu on mobile
             // but maybe we can do it via a CSS class on outerSelf.content instead of inline style
             outerSelf.content.classList.add('overflow-hidden');
          }
        }
        const animation = doAnimate();
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (window.innerWidth > 991 && isLevel2) {
          if (this.button.getAttribute('aria-expanded') === 'true') return;
          if (outerSelf) {
            outerSelf.querySelectorAll('menu-mega-dropdown[data-level="2"]').forEach(el => {
              if (el !== this) el.closeDropdown();
            });
          }
        }
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
        
        const itemLink = this.querySelector('a');
        if (itemLink) {
          itemLink.addEventListener('click', (e) => {
            if (window.innerWidth > 991) {
              e.preventDefault();
              this.onButtonClick();
            }
          });
        }
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-mega-dropdown')) customElements.define('menu-mega-dropdown', MenuMegaDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-dropdown-burger"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuBurgerDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-burger-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-burger-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        this.content.style.maxHeight = '100vh';
        this.content.style.overflowY = 'auto';
        if (isLevel2 && outerSelf && outerSelf.content) outerSelf.content.style.overflowY = 'hidden';
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.finished.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          }).catch(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-burger-dropdown')) customElements.define('menu-burger-dropdown', MenuBurgerDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-dropdown-burger"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuBurgerDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-burger-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-burger-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        this.content.style.maxHeight = '100vh';
        this.content.style.overflowY = 'auto';
        if (isLevel2 && outerSelf && outerSelf.content) outerSelf.content.style.overflowY = 'hidden';
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.finished.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          }).catch(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-burger-dropdown')) customElements.define('menu-burger-dropdown', MenuBurgerDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-dropdown"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class MenuDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      const isLevel2 = this.dataset.level === '2';
      const outerSelf = this.closest('menu-dropdown[data-level="1"]');
      this.outerSelf = outerSelf;
      const animationFrames = (() => {
        try { return JSON.parse(this.content.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.content.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = () => {
        if (!animationFrames || !timing) return;
        const getResponsiveData = (data, key) => {
          if (Array.isArray(data) && data.length > 0 && data[0].hasOwnProperty('query')) {
            const sorted = [...data].sort((a, b) => b.query - a.query);
            const match = sorted.find(item => window.innerWidth >= item.query);
            return match ? match[key] : data[0][key];
          }
          return data;
        };
        const frames = getResponsiveData(animationFrames, 'frames');
        const options = getResponsiveData(timing, 'options');
        return this.content.animate(frames, options);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query) || screen.width >= query) this.content.classList.add(...classes);
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', false);
        this.content.classList.remove('dropdown--open');
        const otherOpen = document.querySelectorAll('menu-dropdown .dropdown--open');
        if (otherOpen.length === 0) document.body.classList.remove('overflow-hidden');
        if (isLevel2 && outerSelf) {
          trapFocus(outerSelf.content);
          if (outerSelf.content && this.onParentScroll) outerSelf.content.removeEventListener('scroll', this.onParentScroll);
          if (window.innerWidth < 992 && outerSelf.content) outerSelf.content.style.overflowY = 'auto';
        }
        if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
        this.button.focus();
        document.body.removeEventListener('click', this.onBodyClick);
        this.removeEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:close'));
      };
      const openDropdown = () => {
        this.button.setAttribute('aria-expanded', true);
        this.content.classList.add('dropdown--open');
        this.content.style.position = '';
        this.content.style.marginTop = '';
        this.content.style.maxHeight = '';
        this.content.style.overflowY = '';
        this.content.style.top = '';
        this.content.style.left = '';
        document.body.classList.add('overflow-hidden');
        if (window.innerWidth > 991) {
          if (isLevel2) {
            this.content.style.position = 'fixed';
            const linkRect = this.firstElementChild.getBoundingClientRect();
            let topPosition = linkRect.top;
            let leftPosition = linkRect.right + 5;
            this.content.style.top = `${topPosition}px`;
            this.content.style.left = `${leftPosition}px`;
            const contentWidth = this.content.offsetWidth || 232;
            if (leftPosition + contentWidth > window.innerWidth) this.content.style.left = `${Math.max(0, linkRect.left - contentWidth - 5)}px`;
            if (outerSelf && outerSelf.content) {
              this.onParentScroll = () => closeDropdown();
              outerSelf.content.addEventListener('scroll', this.onParentScroll, { passive: true });
            }
          }
          const rect = this.content.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const padding = 15;
          if (rect.bottom > viewportHeight) {
            if (isLevel2) {
              const overflowAmount = rect.bottom - viewportHeight + padding;
              let currentTop = parseFloat(this.content.style.top) || rect.top;
              const maxShift = Math.max(0, currentTop - padding);
              const actualShift = Math.min(overflowAmount, maxShift);
              this.content.style.top = `${currentTop - actualShift}px`;
              if (overflowAmount > maxShift) {
                this.content.style.maxHeight = `${viewportHeight - (padding * 2)}px`;
                this.content.style.overflowY = 'auto';
              }
            } else {
              this.content.style.maxHeight = `${Math.max(100, viewportHeight - rect.top - padding)}px`;
              this.content.style.overflowY = 'auto';
            }
          }
        } else {
          this.content.style.maxHeight = '100vh';
          this.content.style.overflowY = 'auto';
          if (isLevel2 && outerSelf && outerSelf.content) outerSelf.content.style.overflowY = 'hidden';
        }
        const animation = doAnimate();
        if (animation) {
          const originalOverflow = this.content.style.overflowY;
          this.content.style.overflowY = 'hidden';
          animation.finished.then(() => {
            this.content.style.overflowY = originalOverflow || '';
          }).catch(() => {
            this.content.style.overflowY = originalOverflow || '';
          });
        }
        this.content.focus();
        trapFocus(this.content);
        this.onWindowResize = () => closeDropdown();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
        document.body.addEventListener('click', this.onBodyClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.dispatchEvent(new CustomEvent('dropdown:open'));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          this.contains(target) ||
          target === this ||
          (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const onButtonClick = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return closeDropdown();
        openDropdown();
      };
      const onParentOpen = () => this.button.addEventListener('click', this.onButtonClick);
      const onParentClose = () => {
        this.button.removeEventListener('click', this.onButtonClick);
        if (this.button.getAttribute('aria-expanded') === 'true') closeDropdown();
      };
      this.onBodyClick = onBodyClick;
      this.onKeyUp = onKeyUp;
      this.onButtonClick = onButtonClick;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      this.onParentOpen = onParentOpen;
      this.onParentClose = onParentClose;
      applyColorScheme();
      if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      if (isLevel2 && outerSelf) {
        outerSelf.addEventListener('dropdown:open', this.onParentOpen);
        outerSelf.addEventListener('dropdown:close', this.onParentClose);
        if (outerSelf.content && outerSelf.content.classList.contains('dropdown--open')) this.onParentOpen();
      } else {
        this.button.addEventListener('click', this.onButtonClick);
      }
    }
    disconnectedCallback() {
      if (this.button && this.onButtonClick) this.button.removeEventListener('click', this.onButtonClick);
      if (this.onBodyClick) document.body.removeEventListener('click', this.onBodyClick);
      if (this.onKeyUp) this.removeEventListener('keyup', this.onKeyUp);
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.outerSelf) {
        if (this.outerSelf.content && this.onParentScroll) this.outerSelf.content.removeEventListener('scroll', this.onParentScroll);
        if (this.onParentOpen) this.outerSelf.removeEventListener('dropdown:open', this.onParentOpen);
        if (this.onParentClose) this.outerSelf.removeEventListener('dropdown:close', this.onParentClose);
      }
    }
  }
  if (!customElements.get('menu-dropdown')) customElements.define('menu-dropdown', MenuDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pickup-options"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalPickupToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-pickup-toggler')) customElements.define('modal-pickup-toggler', ModalPickupToggler);
  class ModalPickupComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-pickup-component')) customElements.define('modal-pickup-component', ModalPickupComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-placeholder-style-3"] && !Shopify.designMode) return;
  try {
    if (!window.productCardHoverInitialized) {
    window.productCardHoverInitialized = true;
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.add('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.add('--border-gradient');
      }
    });

    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.remove('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.remove('--border-gradient');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-style-3"] && !Shopify.designMode) return;
  try {
    if (!window.productCardHoverInitialized) {
    window.productCardHoverInitialized = true;
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.add('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.add('--border-gradient');
      }
    });

    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.remove('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.remove('--border-gradient');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.productCardHoverInitialized) {
    window.productCardHoverInitialized = true;
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.add('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.add('--border-gradient');
      }
    });

    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.remove('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.remove('--border-gradient');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-column-card"] && !Shopify.designMode) return;
  try {
    if (!window.productCardHoverInitialized) {
    window.productCardHoverInitialized = true;
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.add('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.add('--border-gradient');
      }
    });

    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('[data-hover-border]');
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.remove('--q-border', '--border-gradient');
        const syncItem = card.querySelector('[data-hover-sync]');
        if (syncItem) syncItem.classList.remove('--border-gradient');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-javascript"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalQuickToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-quick-toggler'))
    customElements.define('modal-quick-toggler', ModalQuickToggler);
  class ModalQuickRenderComponent extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);

      this.applyColorScheme = (body) => {
        const { colorScheme } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      this.applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }

    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }

    close() {
      const parent = this.querySelector(this.dataset.selector);
      if (parent) parent.innerHTML = '';
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }

    
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }

    renderModal() {
      if (this.isFetching) return;
      this.isFetching = true;
      toggleLoader(true);

      let baseUrl = this.dataset.url || window.shopUrl;
      if (this.toggler && this.toggler.dataset.url) {
        baseUrl = this.toggler.dataset.url;
      }
      
      fetch(baseUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const mainProductInner = html.querySelector('.main-product');
          const sectionHtml = mainProductInner ? mainProductInner.closest('.shopify-section') : null;
          
            const parent = this.querySelector(this.dataset.selector);
            if (parent && sectionHtml) {
              // Synchronize color scheme with the fetched section
              const wrapper = this.querySelector('.modal-component_wrapper');
              if (wrapper) {
                // Find any element with a scheme class in the fetched HTML
                const elementWithScheme = html.querySelector('[class*="scheme--"]');
                if (elementWithScheme) {
                  // Remove existing scheme classes from wrapper
                  Array.from(wrapper.classList).forEach((cls) => {
                    if (cls.startsWith('scheme')) wrapper.classList.remove(cls);
                  });
                  // Add new scheme classes from the found element
                  Array.from(elementWithScheme.classList).forEach((cls) => {
                    if (cls.startsWith('scheme')) wrapper.classList.add(cls);
                  });
                }
              }

              parent.innerHTML = sectionHtml.outerHTML;
              
              if (window.initProductPage) {
                window.initProductPage(parent);
              }

              this.dispatchEvent(new CustomEvent('modal:rendered', { bubbles: true }));
            } else {
            console.error('Main product section not found in fetched page', { url: baseUrl });
            this.close();
          }
        })
        .catch((e) => {
          console.error(e);
          this.close();
        })
        .finally(() => {
          this.isFetching = false;
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.setListeners(true);
          toggleLoader(false);
        });
    }

    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }

    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      if (flag) {
        this.addEventListener('keyup', this.onKeyUp);
        this.addEventListener('click', this.onBodyClick);
      } else {
        this.removeEventListener('keyup', this.onKeyUp);
        this.removeEventListener('click', this.onBodyClick);
      }
    }

    onBodyClick(event) {
      const target = event.target;
      const isOverlay = target.classList.contains('modal-component') || 
                        target.classList.contains('modal-component_spacer');
      if (isOverlay) {
        this.close();
      }
    }

    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-quick-render-component'))
    customElements.define('modal-quick-render-component', ModalQuickRenderComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reel-card"] && !Shopify.designMode) return;
  try {
    class DeferredMedia extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-deferred-media-toggler]');
      this.template = this.querySelector('template');
      const loadMedia = () => {
        if (this.dataset.onHover !== 'true' && typeof window.pauseElementBasedMedia === 'function') {
          window.pauseElementBasedMedia(document.body, this);
        }
        if (this.getAttribute('loaded') === 'true') return;
        this.setAttribute('loaded', 'true');
        if (this.template) {
          const content = this.template.content.cloneNode(true);
          this.appendChild(content);
        }
        const mediaElement = this.querySelector('video, iframe');
        if (mediaElement) {
          mediaElement.focus();
          if (mediaElement.tagName === 'VIDEO') {
            mediaElement.play().catch(() => {});
          } else if (mediaElement.tagName === 'IFRAME') {
            const src = mediaElement.getAttribute('src');
            if (src && !src.includes('autoplay')) {
              mediaElement.setAttribute('src', src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`);
            }
          }
        }
      };
      this.loadMediaHandler = loadMedia;
      if (this.button) this.button.addEventListener('click', this.loadMediaHandler);
    }
    disconnectedCallback() {
      const cleanUp = () => {
        if (this.button && this.loadMediaHandler) this.button.removeEventListener('click', this.loadMediaHandler);
      };
      cleanUp();
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalSearchToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-search-toggler')) customElements.define('modal-search-toggler', ModalSearchToggler);
  class ModalSearchComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const setupPredictiveSearch = () => {
        if (this.predictiveInitialized) return;
        this.input = this.querySelector('[data-predictives="true"]');
        this.predictiveInitialized = true;
        this.form = this.querySelector('form');
        this.cachedResults = [];
        if (window.AbortController) this.abortController = new AbortController();
        this.resultsContainers = {};
        this.initHtml = {};
        try {
          const arrSelectors = JSON.parse(this.dataset.renders || '[]');
          arrSelectors.forEach((selector) => {
            const element = document.querySelector(selector);
            if (element) {
              this.resultsContainers[selector] = element;
              this.initHtml[selector] = element.innerHTML;
            }
          });
        } catch (e) {
          console.error('Expected JSON in data-renders:', e);
        }
        const debounce = (fn, wait) => {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
          };
        };
        const onSubmit = (event) => {
          event.preventDefault();
          this.form.submit();
        };
        this.onSubmit = onSubmit;
        const fetchSearchResults = (terms) => {
          if (typeof toggleLoader === 'function') toggleLoader(true);
          fetch(`${window.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(terms)}&section_id=predictive-organizer&resources[type]=${this.dataset.searchTypes}`, {
            signal: this.abortController?.signal,
          })
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                throw error;
              }
              return response.text();
            })
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const searchObj = {
                searchTerm: this.searchTerm,
                contentHtml: html,
              };
              this.cachedResults.push(searchObj);
              const arr = JSON.parse(this.dataset.renders || '[]');
              arr.forEach((selector) => {
                const element = document.querySelector(selector);
                if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
              });
              self.btnSubmit = self.querySelector('[data-btn-submit]');
              if (self.btnSubmit) self.btnSubmit.addEventListener('click', self.onSubmit);
              if (typeof toggleLoader === 'function') toggleLoader(false);
            })
            .catch((error) => {
              if (typeof toggleLoader === 'function') toggleLoader(false);
              if (error?.code === 20) {
                throw error;
              }
            }
          );
        };
        const showCachedResults = (data, cache) => {
          const cacheDataArr = cache;
          const cachedResults = cacheDataArr.find((results) => results.searchTerm === data.searchTerm);
          const arr = JSON.parse(this.dataset.renders || '[]');
          arr.forEach((selector) => {
            const element = document.querySelector(selector);
            if (element && cachedResults.contentHtml.querySelector(selector))
              element.innerHTML = cachedResults.contentHtml.querySelector(selector).innerHTML;
          });
        };
        const resetResults = (clearInput = false) => {
          this.searchTerm = '';
          if (clearInput && this.input) this.input.value = '';
          for (const key in this.resultsContainers) {
            const container = this.resultsContainers[key];
            if (container) container.innerHTML = this.initHtml[key] || '';
          }
        };
        this.resetResults = resetResults;
        const onInputType = (event) => {
          const inputValueTerm = this.input.value.replace(/\s/g, '');
          if (inputValueTerm.length > 0) {
            this.searchTerm = this.input.value.trim();
            const term = { searchTerm: this.searchTerm };
            if (!this.cachedResults || !this.cachedResults.some((key) => key.searchTerm === term.searchTerm)) {
              fetchSearchResults(this.searchTerm);
              return;
            }
            showCachedResults(term, this.cachedResults);
            return;
          }
          resetResults();
        };

        this.input.addEventListener('input', debounce(onInputType, 500));
      };
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
        const inputPredictive = self.querySelector('[data-predictives="true"]');
        if (inputPredictive) setupPredictiveSearch();
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
        if (self.resetResults) {
          self.resetResults(true);
        } else {
          const form = self.querySelector('form');
          if (form) form.reset();
        }
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-search-component')) customElements.define('modal-search-component', ModalSearchComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-product-row"] && !Shopify.designMode) return;
  try {
    const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if (!links || links.length === 0) return;
    links.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };

  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const formSelectors = getJsonParse(formElems);
    formSelectors.forEach((selector) => {
      const form = document.querySelector(selector);
      if (!form) return;
      const input = form.querySelector('[name="id"]');
      if (!input) return;
      if (!variant) {
        input.value = '';
        return;
      }
      input.value = variant.id;
    });
  };

  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
    }

    onInputChange() {
      const input = this.querySelector('input[type="radio"]:checked');
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      const errElem = this.dataset.errorSelector && this.dataset.errorSelector !== '[]' ? document.querySelector(this.dataset.errorSelector) : null;
      const selElem = this.dataset.selectedParent && this.dataset.selectedParent !== '[]' ? document.querySelector(this.dataset.selectedParent) : null;
      if (!parent) return;
      if (errElem) errElem.classList.add('hidden');
      if (selElem) selElem.innerText = value;
      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;
      const pills = parent.querySelectorAll('search-variant-pill');
      pills.forEach((pill) => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
      this.setOptions(pills, currentSet);
      let availableSet = null;
      if (this.dataset.checkSets === 'true') {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      const finalSet = availableSet ? availableSet : currentSet;

      // Directly update price + image
      this.updatePriceAndImage(finalSet);
    }

    updatePriceAndImage(currentSet) {
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      const data = JSON.parse(json.textContent);
      const variant = data.variants.find((v) =>
        v.options.every((opt, i) => opt === currentSet[i])
      );
      if (!variant) return;

      // Scope to this product's row element
      const rowElem = this.closest('[data-product-link]');
      if (!rowElem) return;

      // --- Update product link URLs so detail page opens on the selected variant ---
      const updateLinks = rowElem.querySelectorAll('[data-update-link]');
      updateLinks.forEach((link) => {
        if (variant.id && link.href) {
          const productUrl = this.dataset.productUrl || link.href.split('?')[0];
          link.href = `${productUrl}?variant=${variant.id}`;
        }
      });

      // --- Update price ---
      if (variant.price) {
        const priceElem = rowElem.querySelector('[data-search-product-price]');
        if (priceElem) {
          let html = '<span class="product-price --word-break"><span class="product-price_pricing">';
          if (variant.compare_at_price) {
            html += '<span class="visually-hidden">Regular price</span>';
            html += `<s class="regular-price --text-alternative">${variant.compare_at_price}</s>`;
            html += '<span class="visually-hidden">Sale price</span>';
            html += `<span class="sale-price main-price">${variant.price}</span>`;
          } else {
            html += '<span class="visually-hidden">Regular price</span>';
            html += `<span class="regular-price main-price">${variant.price}</span>`;
          }
          html += '</span>';
          // --- Unit price ---
          if (variant.unit_price && variant.unit_price_reference_unit) {
            html += '<span class="product-price_unit-pricing">';
            html += '<span class="visually-hidden">Unit price</span>';
            html += '<span class="unit-price">';
            html += `<span>${variant.unit_price}</span>`;
            html += '<span aria-hidden="true">/</span>';
            html += '<span class="visually-hidden">&nbsp;per&nbsp;</span>';
            html += '<span>';
            if (variant.unit_price_reference_value) html += variant.unit_price_reference_value;
            html += variant.unit_price_reference_unit;
            html += '</span></span></span>';
          }
          html += '</span>';
          priceElem.innerHTML = html;
        }
      }

      // --- Update image with fade ---
      if (variant.image_url) {
        const imgWrap = rowElem.querySelector('.search-product-row_image-wrap');
        if (imgWrap) {
          const img = imgWrap.querySelector('img');
          if (img) {
            img.style.transition = 'opacity 0.3s ease';
            img.style.opacity = '0';
            setTimeout(() => {
              img.src = variant.image_url;
              if (variant.image_alt) img.alt = variant.image_alt;
              img.removeAttribute('srcset');
              img.style.opacity = '1';
            }, 300);
          }
        }
      }
    }

    setOptions(elems, set) {
      const json = document.querySelector(this.dataset.jsonSelector);
      const data = JSON.parse(json.textContent);
      const variants = data.variants;
      const selectedOptionOneVariants = variants.filter((variant) => set[0] === variant.option1);
      elems.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
        const previousOptionSelected = elems[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((elem) => {
        const label = elem.nextElementSibling;
        const labelText = label.querySelector('[data-variant-status-text]');
        if (listOfAvailableOptions.includes(elem.getAttribute('value'))) {
          elem.classList.remove('disabled');
          labelText.classList.add('hidden');
          return;
        }
        elem.classList.add('disabled');
        labelText.classList.remove('hidden');
      });
    }
  }
  if (!customElements.get('search-variant-pill')) customElements.define('search-variant-pill', VariantPill);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-with-socials"] && !Shopify.designMode) return;
  try {
    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if(this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if(this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if(!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if(this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if(this.dataset.onHover === 'true' && window.screen.width > 1025){
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open(){
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close(){
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event){
      if(event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event){
      const target = event.target;
      if(this.contains(target) || target === this || target === this.button
        && this.button.getAttribute('aria-expanded') === 'true') return;
      this.doClose(event);
    }

    onKeyUp(event){
      if(event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event){
      if(this.dataset.level === '2'){
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if(parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if(!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class ShareComponent extends DropdownComponent {
    constructor() {
      super();

      this.urlInput = this.querySelector('.shareUrl');
      if(navigator.share){
        this.button.removeEventListener('click', this.onButtonClick);
        this.button.addEventListener('click', () => { navigator.share({ url: this.urlInput.value, title: document.title }); });
        this.classList.add('--share-native');
        return;
      }
      this.classList.remove('--share-native');
      this.successMessage = this.querySelector('.shareMessage');
      this.shareButton = this.querySelector('.share-button__copy');
      this.label = this.querySelector('.share-button__label');
      this.shareButton.addEventListener('click', this.copyToClipboard.bind(this));
    }

    toggleDetails(){
      this.successMessage.classList.add('hidden');
      this.successMessage.textContent = '';
      this.closeButton.classList.add('hidden');
      this.label.classList.remove('hidden');
    }

    copyToClipboard(){
      navigator.clipboard.writeText(this.urlInput.value).then(() => {
        this.successMessage.classList.remove('hidden');
        this.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.closeButton.classList.remove('hidden');
        this.label.classList.add('hidden');
      });
    }

    close(){
      super.close();
      this.toggleDetails();
    }
  }
  if(!customElements.get('share-component')) customElements.define('share-component', ShareComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tab-list-block"] && !Shopify.designMode) return;
  try {
    // tabset
  if (!customElements.get('tabset-component')) {
    customElements.define('tabset-component', class TabsetComponent extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[data-tabset-content]'));
        this.initialize();
      }
      
      initialize(){
        this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
        this.tabs.forEach(tab => {
          tab.addEventListener('click', this.onClick.bind(this));
        });
        if (this.tabs.length > 0) {
          this.setSelectedTab(this.tabs[0], false);
        }
      }
    
      setSelectedTab(currentTab, setFocus = true) {
        this.tabs.forEach((tab, index) => {
          const panel = this.tabpanels[index];
          if (!panel) return;
          const isSelected = currentTab === tab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          panel.classList.toggle('hidden', !isSelected);
        });
      }
    
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
